module.exports = __webpack_public_path__ + "img/s2on.8811c43e.svg";